var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("rest-menu", {
        attrs: {
          restId: _vm.restId,
          restColor: _vm.restInfo.restColor,
          menuTabs: _vm.menuTypeTabs,
          pageBanner: _vm.restInfo.pageBanner,
          restInfoBanner: _vm.restInfo.restInfoBanner,
          deliveryTime: _vm.deliveryTime,
          menuHero: _vm.restInfo.menuHero,
          restInfoModal: _vm.restInfo.restInfoModal,
          showSpecialItem: _vm.restInfo.showSpecialItem,
          cartCount: _vm.cartCount,
          blockedMessage: _vm.restInfo.blockedMessage,
          closedMessage: _vm.restInfo.closedMessage,
          "default-address": _vm.defaultAddress,
          "default-city": _vm.defaultCity,
          "default-state": _vm.defaultState,
          showVerifyAddress: _vm.showVerifyAddress,
          mapCenterLat: _vm.mapCenterLat,
          mapCenterLng: _vm.mapCenterLng,
          restZone: _vm.restZone,
          initDefaultTab: _vm.initDefaultTab,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }